let container = document.querySelector('.cc-hero__videos')
let videos = container.querySelectorAll('.cc-hero__video')
let index = 0
let firstVideoPlayed = false

function playNextVideo() {
  if (!firstVideoPlayed) {
    firstVideoPlayed = true
    index++
  } else {
    index = (index + 1) % videos.length
    if (index === 0) index++
  }

  let activeVideo = container.querySelector('.cc-hero__video--active')

  videos[index].addEventListener('canplaythrough', function () {
    activeVideo.classList.remove('cc-hero__video--active')
    this.classList.add('cc-hero__video--active')
    this.play()
    this.removeEventListener('canplaythrough', arguments.callee)
  })

  videos[index].load()
}

for (let video of videos) {
  video.addEventListener('ended', playNextVideo)
}

setTimeout(() => {
  videos[index].play()
}, 2000)
